import { get } from 'lodash';
import { createSelector } from 'reselect';

export const reviewFacilitySelector = createSelector(
	(state) => state.facilities.byId,
	(state) => state.bookings.byId,
	(state) => state.reviews.reviewFacility,
	(state) => state.reviews.reviewEmail,
	(facilities, bookings, reviewFacility, reviewEmail) => {
		const facility = facilities[reviewFacility] || {};
		const isReviewRequest = reviewEmail.emailName === 'sf-consumer-review-request';

		return {
			facility,
			email: reviewEmail.to,
			source: reviewEmail.emailName,
			confirmationCode: get(reviewEmail, 'parameters.confirmation_code', ''),
			reviewStatus: isReviewRequest ? 'PENDING' : '',
			requireConfirmationCode: !isReviewRequest
		};
	}
);
